<template>
  <div>
    <back-breadcrumb :description="$t('admin.alerts.new.back_to')"/>
    <v-container py-0>
      <v-layout>
        <alert-details-panel v-if="$vuetify.breakpoint.lgAndUp" :panel-colour="panelColour"/>
        <v-flex px-2 :class="bodySection">
          <alert-details-top-panel/>

          <v-layout v-if="bodyLoading" row justify-center align-center fill-height>
            <v-progress-circular
              id="alert-progress-spinner"
              size="200"
              :width="2"
              color="accent"
              indeterminate/>
          </v-layout>

          <alert-details-body :panel-colour="panelColour" :alert-id="alertId" v-if="alertId > 0"/>
        </v-flex>
      </v-layout>
    </v-container>
    <fab-dial v-if="$vuetify.breakpoint.mdAndDown && displayFlag"
              :buttons="buttons"
              :right="fab.right"
              :left="fab.left"
              :text-direction="fab.fabPosition"
              :fab-icon="fab.fabIcon"
              :color="infoColour">
    </fab-dial>

    <v-dialog v-if="currentDialog !== ''" v-model="dialog" max-width="375px">
      <component :is="alertComponent" :panel-colour="panelColour">
        <div v-html="alertComponent"></div>
      </component>
    </v-dialog>
  </div>
</template>

<script>
  import FabDial from '../../misc/fab/FabDial'
  import AlertFrequency from './AlertFrequency'
  import AlertDatasets from './AlertDatasets'
  import AlertTemplates from './AlertTemplates'
  import AlertDetailsPanel from './AlertDetailsPanel'
  import AlertDetailsBody from './AlertDetailsBody'
  import BackBreadcrumb from './BackBreadcrumb'
  import AlertDetailsTopPanel from './AlertDetailsTopPanel'
  import {
    GET_ALERTS_LANDING,
    GET_ALL_COURSES_FOR_ALERTS,
    GET_DATA_SET_ITEMS,
    GET_DELIVERY_METHODS,
    GET_TEMPLATE_PLACEHOLDERS,
    GET_CLASS_HIERARCHY
  } from '../../../store/action-types'
  import {
    SET_ALERT_ID,
    SET_DATA_SET_PROGRESS_ON,
    UPDATE_DATA_SET_PROP,
    UPDATE_TEMPLATE_PROP
  } from '../../../store/mutation-types'
  import { mapMutations } from 'vuex'
  import { getDataSetDescription } from '../../../HelperMethods'

  export default {
    name: 'alerts-details',
    components: {
      AlertDetailsTopPanel,
      BackBreadcrumb,
      AlertDetailsBody,
      AlertDetailsPanel,
      AlertTemplates,
      AlertDatasets,
      AlertFrequency,
      FabDial
    },
    data () {
      return {
        alertId: this.$route.params.id,
        infoColour: this.$vuetify.theme.info,
        fab: {
          fabIcon: 'more_vert',
          fabPosition: 'left',
          right: false,
          left: true
        },
        dialog: false,
        currentDialog: '',
        buttons: [
          {
            icon: 'event',
            text: this.$t('admin.alerts.new.frequency.title'),
            color: this.$vuetify.theme.info,
            action: this.frequencyDialog
          },
          {
            icon: 'notifications_none',
            text: this.$t('admin.alerts.new.data_sets.title'),
            color: this.$vuetify.theme.info,
            action: this.alertTypeDialog
          },
          {
            icon: 'mail_outline',
            text: this.$t('admin.alerts.new.email_templates.title'),
            color: this.$vuetify.theme.info,
            action: this.emailTemplateDialog
          },
          {
            icon: 'delete',
            text: this.$t('admin.alerts.new.delete_alert'),
            color: this.$vuetify.theme.error,
            action: this.emailTemplateDialog
          }]
      }
    },
    methods: {
      frequencyDialog () {
        this.currentDialog = 'frequency'
        this.dialog = true
      },
      alertTypeDialog () {
        this.currentDialog = 'datasets'
        this.dialog = true
      },
      emailTemplateDialog () {
        this.currentDialog = 'templates'
        this.dialog = true
      },
      translateDescription (dataSet) {
        let key = getDataSetDescription(dataSet)
        return this.$t(key.text, {x: key.x, y: key.y, z: key.z, k: this.$t(key.k), kk: this.$t(key.k), d: key.d})
      },
      updateThisDataSetProp (prop) {
        this.updateDataSetProp({
          key: prop.key,
          prop: prop.prop,
          val: prop.val
        })
      },
      updateThisTemplateProp (prop) {
        this.updateTemplateProp({
          key: prop.key,
          prop: prop.prop,
          val: prop.val
        })
      },
      ...mapMutations({
        updateDataSetProp: UPDATE_DATA_SET_PROP,
        updateTemplateProp: UPDATE_TEMPLATE_PROP
      })
    },
    computed: {
      panelColour () {
        return { backgroundColor: this.infoColour, color: 'white' }
      },
      alertComponent () {
        return `alert-${this.currentDialog}`
      },
      bodySection () {
        return this.$vuetify.breakpoint.mdAndDown ? 'xs12' : 'xs9'
      },
      dataSets () {
        return this.$store.state.admin.newSingleAlert.dataSets
      },
      templates () {
        return this.$store.state.admin.newSingleAlert.emailTemplates
      },
      dataSetItems () {
        return this.$store.state.admin.dataSetSelectionItems
      },
      bodyLoading () {
        return this.$store.state.admin.alertDetailsBodyLoading
      },
      displayFlag () {
        return this.$store.state.admin.alertDetailsDisplayFlag
      },
      alertsLength () {
        return Object.keys(this.$store.state.admin.newAlerts).length
      }
    },
    created () {
      if (this.alertId > 0) {
        this.$store.commit(SET_DATA_SET_PROGRESS_ON)
        this.$store.commit(SET_ALERT_ID, this.alertId)
        this.$store.dispatch(GET_TEMPLATE_PLACEHOLDERS)
        this.$store.dispatch(GET_DELIVERY_METHODS)
        this.$store.dispatch(GET_DATA_SET_ITEMS)
        this.$store.dispatch(GET_ALL_COURSES_FOR_ALERTS)
        if (this.$store.state.hierarchy.tree === null) {
          this.$store.dispatch(GET_CLASS_HIERARCHY)
        }
      }
      if (this.alertsLength <= 0) {
        this.$store.dispatch(GET_ALERTS_LANDING)
      }
    },
    watch: {
      dataSets (val) {
        if (val) {
          Object.keys(val).forEach(el => {
            this.updateThisDataSetProp({key: el, prop: 'description', val: this.translateDescription(val[el])})
            this.updateThisDataSetProp({key: el, prop: 'editorDescription', val: this.translateDescription(val[el])})
          })
        }
      },
      templates (val) {
        if (val) {
          Object.keys(val).forEach(el => {
            this.updateThisTemplateProp({key: el, prop: 'editorTemplateName', val: (val[el].templateName)})
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDetails.vue